// The fetch used for Edge Function calls (onboard, supervisor). Demo mode swaps in an in-memory stand-in;
// everywhere else it is the browser's fetch.
let impl: typeof fetch | null = null;

export const httpFetch: typeof fetch = (input, init) => (impl ?? fetch)(input, init);

/** Replaces the transport. Only demo mode and tests call this. */
export function setHttpFetch(f: typeof fetch | null): void {
  impl = f;
}
